import Vue from 'vue';
import Vuex from 'vuex';
//import searchPlugin, { SearchApi, INDEX_MODES } from 'vuex-search';
import User from './modules/user';
import Option from './modules/option';
import Product from './modules/product';
import Coupon from './modules/coupon';
import CustomProduct from './modules/customProduct';
import Tag from './modules/tags';
import DeliveryPoints from './modules/deliveryPoints';

import Order from './../../common/MakeOrder/store/modules/order';
import Misc from './../../common/MakeOrder/store/modules/misc';
import Navigation from './../../common/MakeOrder/store/modules/navigation';
import MakeOrderProduct from './../../common/MakeOrder/store/modules/product';

import productless from './../../common/ProductlessOrder/OrderFlow/store/modules/order';

Vue.use(Vuex);


/*const prefixSearchApi = new SearchApi({
    indexMode: INDEX_MODES.PREFIXES,
});*/



export default new Vuex.Store({
    modules: {
        User,
        Option,
        Product,
        Coupon,
        CustomProduct,
        Tag,
        DeliveryPoints,
        Order,
        Misc,
        Navigation,
        MakeOrderProduct,
        productless,
    },
    plugins:[
       /* searchPlugin({
            resources: {
                options: {
                    index: ['title'],
                    getter: state => state.Option.options,
                    watch: { delay: 500 },
                },
                // otherResource: { index, getter, watch, searchApi },
            },
            searchApi: prefixSearchApi,
        }),*/
    ]
})
